import { Alert, Snackbar } from '@mui/material';
import { useToastStore } from '../stores/toast.store';

const AUTO_HIDE_MS = 4000;

export function ToastContainer() {
  const toasts = useToastStore((s) => s.toasts);
  const removeToast = useToastStore((s) => s.removeToast);

  return (
    <>
      {toasts.map((t, index) => (
        <Snackbar
          key={t.id}
          open
          autoHideDuration={AUTO_HIDE_MS}
          onClose={() => removeToast(t.id)}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          sx={{ bottom: { xs: `${24 + index * 60}px` } }}
        >
          <Alert
            onClose={() => removeToast(t.id)}
            severity={t.severity}
            variant="filled"
            sx={{ width: '100%', minWidth: 300 }}
          >
            {t.message}
          </Alert>
        </Snackbar>
      ))}
    </>
  );
}
